export const getUserLoggedInStatus = (store) => store.auth.isLoggedIn || false;
export const getApiData = (store) => store.auth.apiData || {};
export const getLoginData = (store) => store.auth.loginData;
export const getMobileNo = (store) => store.auth.mobileNo;
export const getPatientDetailsPageShown = (store) =>
  store.auth.patientDetailsPageShown;
export const getInstructionsPageShown = (store) =>
  store.auth.instructionsPageShown;
export const getPatientData = (store) => store.auth.PatientDetails;
export const getEProcode = (store) => store.auth.eProcode;
